import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';

/**
 * Inicio de un usuario transportista que no tiene ningún módulo asignado
 * (ni Torre de Control ni Tarifas). Evita mandarlo a una pantalla que le
 * sería negada.
 */
@Component({
    selector: 'app-sin-modulos',
    imports: [RouterLink, MatCardModule, MatButtonModule],
    templateUrl: './sin-modulos.component.html',
})
export class SinModulosComponent {}
